
export enum CreateSteps {
    OPTIMIZE,
    ACCEPT,
    INDICATORS,
    DIFFICULTY,
    NAME,
}

export const DEBOUNCE_CREATE_SEARCH = 300;

export enum TutorialSteps {
    GREETING,
    WELCOME1, // Dot start
    WELCOME2,
    WELCOME3,
    WELCOME4,
    WELCOME5, // Dot end
    SELECT_PARCEL,
    CHANGE_LUC,
    INDICATORS_CHANGED, // Dot start
    SUBMIT_BTN, // dot end
    SUBMITTING_NAME_EXP,
    SUBMITTING_NAME,
    SUBMITTING_CHOOSE_STAKEHOLDERS1, // dot start
    SUBMITTING_CHOOSE_STAKEHOLDERS2, // dot end (ra)
    BUDGET1, // dot start
    BUDGET2, // dot end
    SURVEY_TAB, // dot start
    SURVEY_TAB_2, // dot end (ra)
    SURVEY_TAB_STAKEHOLDER1, // dot start
    SURVEY_TAB_STAKEHOLDER2,
    SURVEY_TAB_CLICK_DATA_TAB, // dot end (ra)
    DATA_TAB, // dot start
    DATA_TAB_INDICATOR,
    DATA_TAB_INDICATOR_EXPAND, // dot end (ra)
    DATA_TAB_GRAPH, // dot start
    DATA_TAB_TARGET_BTN, // dot end (ra)
    DATA_TAB_TARGET_SLIDERS,
    // DATA_TAB_SET_TARGETS,
    DATA_TAB_CLICK_CLOSE,
    INDICATOR_TARGET,
    INDICATOR_TARGET_PLAY,
    INDICATOR_TARGET_HIT, // dot start
    INDICATOR_TARGET_SUBMIT_BTN, // dot end (ra)
    INDICATOR_TARGET_SUBMITTING_NAME,
    INDICATOR_TARGET_SUBMITTING_STAKEHOLDER,
    INDICATOR_TARGET_SUBMITTING_CLICK_SUBMIT,
    SURVEY_TAB_SUBMISSIONS, // dot start
    SURVEY_TAB_STAKEHOLDER_APPROVAL, // dot end (ra)
    SURVEY_TAB_PLAY,
    TABS_CLICK_CLOSE,
    BUDGET_LEFT, // dot start
    MENU_BTN,
    GOOD_LUCK, // dot end
    MAP_PLAY,
    FINAL_SUBMIT,
    DONE,
    DONE2
}
export const TINTED_TUTORIAL_STEPS = [
    TutorialSteps.WELCOME1,
    TutorialSteps.WELCOME2,
    TutorialSteps.WELCOME3,
    TutorialSteps.WELCOME4,
    TutorialSteps.WELCOME5,
    TutorialSteps.CHANGE_LUC,
    TutorialSteps.GOOD_LUCK,
];
export const EXPANDED_TUTORIAL_STEPS = [
    TutorialSteps.WELCOME1,
    TutorialSteps.WELCOME2,
    TutorialSteps.WELCOME3,
    TutorialSteps.WELCOME4,
    TutorialSteps.WELCOME5,
    // TutorialSteps.CHANGE_LUC,
    TutorialSteps.INDICATORS_CHANGED,
    TutorialSteps.SUBMIT_BTN,
    TutorialSteps.SURVEY_TAB,
    TutorialSteps.SURVEY_TAB_2,
    TutorialSteps.MENU_BTN,
    TutorialSteps.BUDGET_LEFT,
    TutorialSteps.GOOD_LUCK,
];
export const HIGH_Z_INDEX_TUTORIAL_STEPS = [
    TutorialSteps.MENU_BTN,
    TutorialSteps.BUDGET_LEFT,
    TutorialSteps.GOOD_LUCK,
];
export const HIDDEN_TUTORIAL_STEPS = [
    // TutorialSteps.DATA_TAB_SET_TARGETS,
    TutorialSteps.INDICATOR_TARGET_PLAY,
];

export enum Positions {
    ABOVE = "above",
    BELOW = "below",
    RIGHT = "right",
    LEFT = "left",
    CENTER = "center",
}

export enum SubmitSteps {
    NAME,
    STAKEHOLDERS,
}

export enum AnalyticsNames {
    APP = "app",
    CREATE = "create-page",
    MAP = "map-page",
    MAPS = "maps-page",
    LOGIN = "login-page",
    REGISTER = "register-page",
    CONFIRM = "confirm-page",
    GMAP_VIEW = "google-map-view-change",
    HOME = "home",
    // MAP_MENU = "map-menu",
}

export const DEBOUNCE_UPDATE_MARKERS = 500;

export const MOBILE_RESIZE_BOTTOM_BAR_DIFF = 50;
export const MOBILE_RESIZE_ADDRESS_BAR_BOTTOM_BAR = 93;
export const MOBILE_RESIZE_ADDRESS_BAR = 0;
export const MOBILE_RESIZE_TIMEOUT = 500;
export const MOBILE_RESIZE_SCROLL_BUFFER = 30;

export const UNLOAD_PROMPT_TEXT = "Are you sure you want to leave? Any unsubmitted changes will be lost.";
export enum GraphDisplayOptions {
    UNITS = "units",
    PERCENTS = "percents",
}
